import * as types from './types'
import DocumentsResource from '@/common/resources/Documents'

const resolveType = (document) => {
	let type = null
	switch (document.category) {
	case 'personal-estate':
		type = 'personalEstate'
		break
	case 'operations':
		type = 'myOperations'
		break
	case 'justificatifs':
		type = 'justificatifs'
		break
	case 'subscriptions':
		type = 'subscriptions'
		break
	case 'autre':
		const tmp = (document.confidential) ? 'private' : 'shared'
		type = tmp
		break
	case 'private':
		type = 'private'
		break
	case 'lcb-ft':
		type = 'lcbft'
		break
	}

	return type
}

// const reverseResolveType = (doc) => {
// 	let result = null
// 	switch (doc.category) {
// 	case 'autre':
// 		const tmp = (document.confidential) ? 'private' : 'shared'
// 		result = tmp
// 		break
// 	case 'justificatifs':
// 		result = 'justificatifs'
// 		break
// 	case 'operations':
// 		result = 'myOperations'
// 		break
// 	}
//
// 	return result
// }

export const actions = {
	fetchDocuments ({ commit }) {
		commit('LOADER_IN')
		commit(types.CLEAR_DOCUMENTS)
		DocumentsResource.getDocuments().then((result) => {
			commit('LOADER_OUT')
			if (result.data.success) {
				result.data.documents.forEach((document) => {
					commit(types.ADD_DOCUMENT, {
						type: resolveType(document),
						document: document
					})
				})
			}
		})
	},
	addDocument ({ commit }, data) {
		const form = new FormData()
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			getBase64File(data.file).then((base64) => {
				data.file = base64
				return data
			}).then((data) => {
				Object.keys(data).forEach((key) => {
					form.append(key, data[key])
				})
				DocumentsResource.addDocument(form).then((result) => {
					if (result.data.success) {
						commit(types.ADD_DOCUMENT, {
							type: resolveType(result.data.document),
							document: result.data.document
						})
						commit('LOADER_OUT')
						resolve(result.data.document)
					} else {
						commit('LOADER_OUT')
						reject(new Error('not a success'))
					}
				}).catch((error) => {
					commit('LOADER_OUT')
					reject(error)
				})
			})
		})
	}
}

const getBase64File = (file) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader()
		reader.onload = () => {
			resolve(reader.result)
		}
		reader.onerror = (error) => {
			reject(error)
		}
		reader.readAsDataURL(file)
	})
}



// WEBPACK FOOTER //
// ./src/common/store/Documents/actions.js